/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NotifyEntityUpdatePage = lazyLoad(
  () => import('./index'),
  module => module.NotifyEntityUpdatePage
);
